<template>
    <el-dialog 
        title="新增客户" 
        :visible.sync="addShow" 
        :close-on-click-modal="false"
        width="750px" 
        ref="dialog" 
        @close="editorClose"
        top="5vh"
    >
        <AddCustomer ref="addCustomer" @confirmSeasFun="onModalSubmit"/>
    </el-dialog>
</template>

<script>
import AddCustomer from './addCustomer'
export default {
  components: {
    AddCustomer
  },
  data() {
    return {
      addShow: false,
    }
  },
  methods: {
    open() {
      this.addShow = true
      this.$nextTick(()=> {
        this.$refs.addCustomer.get()
      })
    },
    editorClose() {
      this.addShow = false
    },
    onModalSubmit(val){
      this.$emit('onSubmit', val)
    },
  }
}
</script>
